import { FaTimes } from 'react-icons/fa';
import { useRef, useState, useEffect} from 'react';
import React from "react";

import '../styles/topnavbar.css';
import bars from '../img/water-waves.png'
import sun from '../img/sunset.png'

const TopNavBar = () => {
    const navRef = useRef();
    const barsRef = useRef();
    const [navbarScroll, setNavbarScroll] = useState(false);

    // Mobile bar button
    const showTopNavBar = () => {
        // Removes the class name from the reference
        navRef.current.classList.toggle("responsive-nav-bar");

        // Hides the bars
        barsRef.current.classList.toggle("hidden");
    }

    const changeNavbarBackground = () => {
        // Toggle the navbar background when passed 300 pixels and this is on desktop display
        if(window.scrollY >= 100 && window.innerWidth >= 768)
        {
            setNavbarScroll(true);
        }
        else
        {
            setNavbarScroll(false);
        }
    }

    // Add event listeners
    window.addEventListener("scroll", changeNavbarBackground);

    useEffect(() => {
        // Freeze the initial viewport height so navbar position doesn't shift when URL bar shows/hides
        const h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
        document.documentElement.style.setProperty('--vh-navbar-frozen', `${h}px`);
    }, []);

    useEffect(() => {
        // Auto-close navbar when user scrolls within the navbar itself
        const handleNavbarScroll = () => {
            if (navRef.current && navRef.current.classList.contains("responsive-nav-bar")) {
                navRef.current.classList.remove("responsive-nav-bar");
                barsRef.current.classList.remove("hidden");
            }
        };

        // Auto-close navbar when viewport resizes using ResizeObserver
        const resizeObserver = new ResizeObserver(() => {
            if (navRef.current && navRef.current.classList.contains("responsive-nav-bar")) {
                navRef.current.classList.remove("responsive-nav-bar");
                barsRef.current.classList.remove("hidden");
            }
        });
        
        resizeObserver.observe(document.documentElement);

        if (navRef.current) {
            navRef.current.addEventListener("scroll", handleNavbarScroll, { passive: true });
        }

        return () => {
            if (navRef.current) {
                navRef.current.removeEventListener("scroll", handleNavbarScroll);
            }
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <div>
            <nav className={navbarScroll? "top-navbar active-top-navbar" : "top-navbar"} ref={navRef}>
                <a className="navbar-logo-link" href="#" onClick={showTopNavBar}><img className="navbar-logo" src={sun} alt="LOGO HERE" /></a>
                <a className="navbar-item hover-lift" href="#about" onClick={showTopNavBar}>About</a>
                <a className="navbar-item hover-lift" href="#experience" onClick={showTopNavBar}>Experience</a>
                <a className="navbar-item hover-lift" href="#skills" onClick={showTopNavBar}>Skills</a>
                <a className="navbar-item hover-lift" href="#projects" onClick={showTopNavBar}>Projects</a>
                <a className="navbar-item hover-lift" href="#contact" onClick={showTopNavBar}>Contact</a>
                <button className="nav-btn nav-close-btn" onClick={showTopNavBar}>
                    <FaTimes/>
                </button>
            </nav>
            <img className="nav-btn bars-icon" ref={barsRef} src={bars} alt="" onClick={showTopNavBar} />
        </div>
    );
}

export default TopNavBar;
